import { createContext, useContext } from 'react'

type FullscreenContextType = { fullscreenToggle: () => void; isFullscreen: boolean }

export const FullscreenContext = createContext<FullscreenContextType>({} as FullscreenContextType)
export const useFullscreenContext = () => useContext(FullscreenContext)!
